/* ============
 * Getters for the formalities module
 * ============
 *
 * The getters that are available on the
 * formalities module.
 */

export default {
  maxAmountInfo: state => { return state.maxAmount }
}



// WEBPACK FOOTER //
// ./src/store/modules/endorsements/getters.js